import { useEffect, useState } from "react";

/**
 * The current time, re-read on each `stepMs` boundary. Each tick schedules the next
 * one (chained `setTimeout`, never `setInterval`), so a throttled background tab
 * cannot pile up ticks and the display lands on the wall-clock second.
 */
export const useDailyNow = (stepMs: number): number => {
    const [now, setNow] = useState<number>(() => Date.now());

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | null = null;
        const schedule = (): void => {
            timer = setTimeout(() => {
                setNow(Date.now());
                schedule();
            }, stepMs - (Date.now() % stepMs));
        };
        schedule();
        return () => {
            if (timer !== null) clearTimeout(timer);
        };
    }, [stepMs]);

    return now;
};
